module.exports = __webpack_public_path__ + "media/images/technology/lab-2-f72190582fcd5b7e3de85c2aba079af7.png";